const services = [
  // Academic Writing
  { name: 'Full Research Paper Writing', category: 'Academic Writing', tier: 'tier-premium', tierLabel: 'Premium', price: 'Conference: ₹1,500–2,500 | Journal: ₹3,000–5,000', delivery: '10–20 days', includes: 'Any domain, references, APA/MLA/IEEE, abstract & keywords' },
  { name: 'Literature Review Writing', category: 'Academic Writing', tier: 'tier-standard', tierLabel: 'Standard', price: 'Conference: ₹1,500 | Journal: ₹2,500', delivery: '5–10 days', includes: 'Comprehensive review, gap analysis, thematic organization' },
  { name: 'Thesis / Dissertation Chapter', category: 'Academic Writing', tier: 'tier-enterprise', tierLabel: 'Enterprise', price: '₹3,500 – ₹7,500 / chapter', delivery: '7–15 days', includes: 'PhD/Masters level, university guidelines, proper citations' },
  { name: 'Research Proposal Writing', category: 'Academic Writing', tier: 'tier-standard', tierLabel: 'Standard', price: '₹1,200 – ₹3,500', delivery: '5–8 days', includes: 'Research objectives, methodology, timeline, literature gap' },
  // Plagiarism & AI Detection
  { name: 'Plagiarism Removal', category: 'Plagiarism & AI Detection', tier: 'tier-standard', tierLabel: 'Standard', price: '₹500 – ₹2,000 / 1000 words', delivery: '1–3 days', includes: 'Turnitin/iThenticate safe, under 5% similarity, report provided' },
  { name: 'AI Content Removal / Humanizing', category: 'Plagiarism & AI Detection', tier: 'tier-standard', tierLabel: 'Standard', price: '₹600 – ₹2,500 / 1000 words', delivery: '1–3 days', includes: 'GPTZero bypass, Originality.AI bypass, natural academic tone' },
  { name: 'Grammar & Proofreading', category: 'Plagiarism & AI Detection', tier: 'tier-basic', tierLabel: 'Basic', price: '₹300 – ₹1,000 / 1000 words', delivery: '1–2 days', includes: 'Grammar correction, clarity, academic tone, consistency check' },
  // Data Analysis
  { name: 'Data Analysis (SPSS/R/Python)', category: 'Data Analysis', tier: 'tier-premium', tierLabel: 'Premium', price: '₹1,500 – ₹3,000', delivery: '3–7 days', includes: 'Regression, ANOVA, descriptive stats, interpretation report, charts' },
  // Journal & Publication
  { name: 'Journal Formatting', category: 'Journal & Publication', tier: 'tier-basic', tierLabel: 'Basic', price: '₹1,000 – ₹3,000', delivery: '1–3 days', includes: 'APA, MLA, IEEE, Chicago — citation formatting, submission ready' },
  { name: 'Conference Formatting', category: 'Journal & Publication', tier: 'tier-basic', tierLabel: 'Basic', price: '₹500 – ₹1,500', delivery: '1–2 days', includes: 'IEEE/ACM/Springer templates, citation formatting, submission ready' },
];

const CATEGORY_COLORS = {
  'Academic Writing': '#1800ad',
  'Plagiarism & AI Detection': '#5b3fff',
  'Data Analysis': '#1800ad',
  'Journal & Publication': '#5b3fff',
};

export default function Research() {
  let lastCat = null;
  return (
    <div className="d-card">
      <div className="d-ctitle">Research & Technical Services — Service Packages</div>
      <table className="d-table">
        <thead>
          <tr>
            <th>Package / Service</th>
            <th>Category</th>
            <th>Type</th>
            <th>Price Range</th>
            <th>Delivery</th>
            <th>Includes</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {services.map((s, i) => {
            const showCat = s.category !== lastCat;
            lastCat = s.category;
            return (
              <>
                {showCat && (
                  <tr key={s.category + '-header'}>
                    <td colSpan={7} style={{ background: '#eef0ff', fontWeight: 700, fontSize: 12, color: CATEGORY_COLORS[s.category], padding: '8px 12px', borderBottom: '1px solid #c5caff' }}>
                      📄 {s.category}
                    </td>
                  </tr>
                )}
                <tr key={s.name}>
                  <td><b style={{ color: '#1a1a1a' }}>{s.name}</b></td>
                  <td style={{ fontSize: 11, color: '#666' }}>{s.category}</td>
                  <td><span className={`pricing-tier ${s.tier}`}>{s.tierLabel}</span></td>
                  <td style={{ color: '#1800ad', fontWeight: 600 }}>{s.price}</td>
                  <td>{s.delivery}</td>
                  <td style={{ fontSize: 11, color: '#444' }}>{s.includes}</td>
                  <td><span className="d-st s-active">Active</span></td>
                </tr>
              </>
            );
          })}
        </tbody>
      </table>
      <div style={{ marginTop: 14, background: '#eef0ff', padding: 12, borderRadius: 8, fontSize: 13, color: '#3d3555', border: '1px solid #c5caff' }}>
        💡 <b>LathiNyx DevLabs</b> pricing is flexible. Custom quotes available for complex projects. Contact via <a href="https://lathinyxdevlabs.com" target="_blank" rel="noreferrer" style={{ color: '#1800ad' }}>lathinyxdevlabs.com</a>
      </div>
    </div>
  );
}
